module.exports = __webpack_public_path__ + "static/media/tab-tv.9f91203b.png";